import { render } from "./ImpactFaces.vue?vue&type=template&id=d7d50e2c&scoped=true"
import script from "./ImpactFaces.vue?vue&type=script&lang=js"
export * from "./ImpactFaces.vue?vue&type=script&lang=js"

import "./ImpactFaces.vue?vue&type=style&index=0&id=d7d50e2c&scoped=true&lang=css"

import exportComponent from "/Users/daiabromberg/Downloads/Parsons_Spring/MS2/msdv-thesis/Project/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7d50e2c"]])

export default __exports__